import { IconMenu2, IconX } from '@tabler/icons-react'
import Image from 'next/image'
import type { ComponentProps } from 'react'

import { MenuButton } from '@/shared/ui/Header/MenuButton/index'
import { HeaderContainer } from '@/shared/ui/Header/styles'
import { ProgressBar } from '@/shared/ui/ProgressBar/index'
import { Stepper } from '@/shared/ui/Stepper/index'

import flashLogo from 'public/assets/images/flash-logo-header.svg'

type HeaderProps = ComponentProps<typeof HeaderContainer> & {
  steps?: string[]
  currentStep?: number
  isMenuOpen?: boolean
  onMenuToggle?: () => void
}

export function Header({
  steps = [],
  currentStep = 1,
  isMenuOpen,
  onMenuToggle,
  ...props
}: HeaderProps) {
  return (
    <HeaderContainer {...props}>
      <Image src={flashLogo} width={112.69} height={40} quality={100} alt="" />

      {steps.length > 0 && (
        <Stepper
          currentStep={currentStep}
          variant="numbered"
          direction="horizontal"
          steps={steps}
          isMenuOpen={false}
        />
      )}

      {steps.length > 0 && (
        <MenuButton
          aria-label={isMenuOpen ? 'fechar menu' : 'abrir menu'}
          title={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          isOpen={isMenuOpen}
          onClick={onMenuToggle}
        >
          {isMenuOpen ? <IconX /> : <IconMenu2 />}
        </MenuButton>
      )}

      {steps.length > 0 && (
        <ProgressBar
          value={currentStep}
          max={steps.length}
          aria-valuemin={1}
          aria-valuemax={steps.length}
          aria-valuenow={currentStep}
        />
      )}
    </HeaderContainer>
  )
}
